import React, { useEffect, useState } from 'react'
import { withRouter, Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Loader from '../Loader'
// import { logout } from '../../actions/user';
// import { getNotifications, sendRequest, markRead } from '../../actions/connection';
import { Row, Col } from 'reactstrap'
import Sidebar from './sidebar'
import ScrollArea from 'react-scrollbar'
//import InfiniteScroll from 'react-infinite-scroll-component';
import { getFile } from '../../utilities/common'
//import Socket from '../../components/socket';
import { useSelector, useDispatch } from 'react-redux'
//import Invite from '../../containers/popups/invite';
import { User } from '../../auth'

const Header = ({ history }) => {
    const loader = useSelector((state) => state.loader)

    return (
        <div id="header-main-wrapper" className="container-fluid ">
            {/* <Sidebar /> */}
            {/* <div className="mobile-sidebar-icon ">
                        <div className="sr-icon"></div>
                        <div className="sr-icon"></div>
                        <div className="sr-icon"></div>
                    </div> */}

            {/* <Loader loading={loader.isFetching} /> */}
        </div>
    )
}

export default withRouter(Header)
